import { useState, useEffect } from 'react';
import {
  useLocation,
  useParams,
  useNavigate,
  generatePath,
} from 'react-router-dom';
import {
  SidePanel,
  SidePanelLoader,
  SidePanelType,
  IconAttention,
  ButtonSecondary,
  ButtonPseudo,
  IconBack,
  formatDate,
} from '@ui/src';
import { useAppDispatch, useAppSelector } from '@store';
import TransactionItem from '../../components/cards/transaction-item';
import {
  getTransaction,
  chargeback,
  fraud,
  clearTransactionItemState,
} from './store/slices/transaction';
import { CardsRoutes } from '../../routes';

import cn from './cards.module.css';

const TransactionSidepanel = () => {
  const [panelIsOpen, setPanelIsOpen] = useState(false);

  const {
    isLoading,
    transaction,
    chargebackRequestInProgress,
    fraudRequestInProgress,
  } = useAppSelector((state) => state.cards.transaction);

  const { cardId, id, transactionId } = useParams();
  const { search } = useLocation();
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const handleClose = () => {
    setPanelIsOpen(false);

    setTimeout(() => {
      navigate(
        generatePath(`${CardsRoutes.CARD_INFO_TRANSACTIONS}${search || ''}`, {
          cardId: cardId as string,
          id: id as string,
        }),
      );
    }, 100);
  };

  useEffect(() => {
    setPanelIsOpen(true);

    if (transactionId) {
      dispatch(getTransaction(transactionId));
    }

    return () => {
      dispatch(clearTransactionItemState());
    };
  }, [dispatch, transactionId]);

  let content;

  if (isLoading) {
    content = <SidePanelLoader />;
  } else {
    content = <TransactionItem transaction={transaction} />;
  }

  return (
    <SidePanel
      type={SidePanelType.Fees}
      closeOnClickOutside
      isOpen={panelIsOpen}
      onClose={handleClose}
      title={transaction ? formatDate(transaction.date, true) : ''}
      sidepanelExpandedKey="card-transactions"
      footer={
        <>
          <ButtonSecondary
            className={`button-white ${cn.buttonChargeback}`}
            text={chargebackRequestInProgress ? 'Loading...' : 'Chargeback'}
            icon={<IconBack />}
            onClick={() => dispatch(chargeback())}
            bold
          />
          <ButtonPseudo
            className={`button-white button-warning ${cn.buttonFraud}`}
            text={fraudRequestInProgress ? 'Loading...' : 'Fraud'}
            icon={<IconAttention />}
            onClick={() => dispatch(fraud())}
            bold
          />
        </>
      }
    >
      {content}
    </SidePanel>
  );
};

export default TransactionSidepanel;
